import { useCallback } from 'react'
import { ModalProps } from '../../DAIComponents/Modal/ModalProps'
import useProfileContext from '../../hooks/useProfileContext'
import { useParams } from 'react-router-dom'
import CreateSaleModal from '../../pages/Sales/CreateSaleModal'
import { Sale } from '../Sales/SalesTypes'

export default function CreateProfileSaleModal(props: ModalProps<Sale>) {
  const { id } = useParams()
  const { createSale, editSale } = useProfileContext()

  const onSubmit = useCallback(
    async (data: Sale) => {
      if (props.initialData) {
        const updateData = {
          ...data,
          contactId: id!,
        }
        await editSale(updateData)
      } else {
        const createData = {
          ...data,
          contactId: id!,
        }
        await createSale(createData)
      }
    },
    [createSale, editSale, id, props.initialData]
  )

  return (
    <CreateSaleModal
      isOpen={true}
      closeModal={props.closeModal}
      initialData={props.initialData}
      onSubmit={onSubmit}
      openModal={props.openModal}
    />
  )
}
